import { type Device } from '@pitbrain/shared'

export const GOPRO: Device = { name: 'GoPro', version: '8' }
